import AccessibilityIcon from "@material-ui/icons/Accessibility";

import { token } from "functions/Helper";
import ImpersonateList from "views/Impersonate/ImpersonateList";

const impersonate = () => {
  let views = [];
  if (
    token["agent.impersonations.impersonate"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/Impersonate",
      name: "Impersonate",
      icon: AccessibilityIcon,
      component: ImpersonateList,
      layout: "/admin"
    });

  return views;
};

export { impersonate };
